/**
 * Every user-facing string of the guided Rock setup shell
 * (`/setup/rock/:connectionId`, ROCK-ONBOARDING-REWORK T4). The step bodies
 * carry their own copy: Match, Measurements and first values in
 * `measurements/setup/copy.js`, Discover, Review and Summary (T5) in
 * `measurements/setup/onboarding/copy.js`.
 *
 * Vocabulary rule (as in the setup copy): never show adopt, wire,
 * realization, partition, dimension, binding, pipeline or setup run.
 */

// --- T4: shell ---------------------------------------------------------------

export const SETUP_TITLE = 'Set up Rock'
export const SAVE_AND_EXIT = 'Save and exit'
export const BACK = 'Back'
export const CONTINUE = 'Continue'
/** E07: Measurements' Continue before the run is started (or manual chosen) led to an empty Review. */
export const MEASUREMENTS_CONTINUE_HINT = 'Set up the measurements above first, or choose them manually.'
export const SAVING = 'Saving…'
export const STEP_INDICATOR_LABEL = 'Setup progress'

export const CREATE_DASHBOARD = 'Create dashboard'
export const CREATING = 'Creating…'
export const GO_TO_DASHBOARD = 'Go to dashboard'
export const FINISH = 'Finish'

/** Step names, in order (the step indicator). */
export const SETUP_STEP_LABELS = {
  discover: 'Discover',
  match: 'Match campuses & service times',
  measurements: 'Measurements',
  suggestions: 'Suggested for you',
  review: 'Review',
  summary: 'Summary',
}

/** Each step's page heading (the one `h1`). */
export const SETUP_STEP_TITLES = {
  discover: 'Here’s what’s in your Rock',
  match: 'Match campuses & service times',
  measurements: 'Choose measurements',
  suggestions: 'Suggested for you',
  review: 'Here’s your starter dashboard',
  summary: 'You’re set up',
}

/** One line under each step's heading. */
export const SETUP_STEP_INTROS = {
  discover: 'Graphit reads what your Rock already has: metrics, campuses and service times.',
  match: 'Tell Graphit which of its campuses and service times are the same as Rock’s, so every number lands in the right place.',
  measurements: 'Graphit can set up your measurements for you, or you can pick them yourself.',
  suggestions: 'Metrics worth tracking, from what your Rock shows your church does most weeks.',
  review: 'Built from the Rock measurements with current data. Remove anything you don’t want, then create it.',
  summary: 'What’s set up, what’s syncing, and when the first numbers arrive.',
}

export const STATE_SAVE_FAILED = 'Couldn’t save your progress. Try again.'

// --- T4: guard ----------------------------------------------------------------

export const ADMINS_ONLY_TOAST = 'Only owners and administrators can set up Rock.'
export const NOT_FOUND_TITLE = 'We couldn’t find that Rock connection'
export const NOT_FOUND_MESSAGE = 'It may have been removed. Open Integrations to connect Rock again.'
export { OPEN_INTEGRATIONS } from '../../../copy/common.js'
export const LOAD_FAILED_TITLE = 'Couldn’t load your Rock connection'
export const LOAD_FAILED_MESSAGE = 'Check your connection, then try again.'
export const FRAMED_TITLE = 'Finish setting up Rock in Graphit'
export const FRAMED_MESSAGE = 'Rock setup opens in its own tab.'
export const OPEN_GRAPHIT = 'Open Graphit'

// --- T4: pending signal (banner, sidebar) ---------------------------------------

export const FINISH_ROCK_SETUP = 'Finish Rock setup'
